import { SET_USER_DATA, UPDATE_USER_IMAGE, LOGOUT_USER, SET_BILLING_ADDRESS, } from '../redux/actions/userActions';

const initialState = {
  userData: null,
  billingAddress: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return action.payload; // Return user data directly without nesting

    case UPDATE_USER_IMAGE:
      return {
        ...state,
        profile_image: action.payload, // Update the profile image
      };

    case LOGOUT_USER:
      return null; // Clear user data on logout

    case SET_BILLING_ADDRESS:
      return {
        ...state,
        billingAddress: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;